module.exports = __webpack_public_path__ + "media/images/home/main/aa/vendors2-bef3d712daeacbfcaadca7b3d5d88b0c.png";